import { css } from '@linaria/core';
import { baseTheme } from 'styles/utils';
import { base } from 'styles/variables';
export const formContainer = "odules__Models__components__ModelForm__styles_tsx-formContainer-f1xep7rl";
export const footerContainer = "odules__Models__components__ModelForm__styles_tsx-footerContainer-fwp0gwd";
export const inputContainer = "odules__Models__components__ModelForm__styles_tsx-inputContainer-igfw321";
export const labelStyle = "odules__Models__components__ModelForm__styles_tsx-labelStyle-lna621r";
export const textGenInputStyle = "odules__Models__components__ModelForm__styles_tsx-textGenInputStyle-ttj8k7x";
export const inputStyle = "odules__Models__components__ModelForm__styles_tsx-inputStyle-iwycf86";
export const selectStyle = "odules__Models__components__ModelForm__styles_tsx-selectStyle-s10vbyp5";
export const ulBorder = `
  border: #ddd 1px solid;
`;
export const alertWrapper = "odules__Models__components__ModelForm__styles_tsx-alertWrapper-a1w6sx0h";
export const descriptionWrapper = "odules__Models__components__ModelForm__styles_tsx-descriptionWrapper-d1k6nm9i";
export const advancedOptionsButton = "odules__Models__components__ModelForm__styles_tsx-advancedOptionsButton-a1wstnux";
export const templateOptionsButton = "odules__Models__components__ModelForm__styles_tsx-templateOptionsButton-t1ka5uir";
export const paddingBottom = "odules__Models__components__ModelForm__styles_tsx-paddingBottom-pebc8jy";
export const helpText = "odules__Models__components__ModelForm__styles_tsx-helpText-h138mbro";
export const stepTitleStyle = "odules__Models__components__ModelForm__styles_tsx-stepTitleStyle-sb4rsln";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.tsx");